module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "goods-banner"
  }, [_c('van-swipe', {
    attrs: {
      "indicator-color": "white",
      "duration": _vm.time
    }
  }, [(_vm.detail.videos_url) ? _c('van-swipe-item', {
    on: {
      "click": _vm.toGoodsVideo
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.detail.videos_url),
      expression: "detail.videos_url"
    }],
    attrs: {
      "src": _vm.detail.videos_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "video-img",
    attrs: {
      "src": require("../../../assets/images/icon-video-play.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.detail.pics_url), function(item) {
    return _c('van-swipe-item', {
      key: item.id
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-name"
  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "goods-pri"
  }, [_c('div', {
    staticClass: "goods-price"
  }, [_vm._v("\n                ¥"), _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.detail.price_range[0])))])]), _vm._v(" "), _c('div', {
    staticClass: "goods-price-thr gray-light"
  }, [_vm._v("\n                ¥" + _vm._s(_vm._f("price")(_vm.detail.orig_price)) + "\n            ")]), _vm._v(" "), (_vm.detail.max_seller_reward > 0) ? _c('div', {
    staticClass: "good-pri-earn",
    on: {
      "click": _vm.onRule
    }
  }, [_c('div', [_vm._v("分享可赚￥{{detail.max_seller_reward/100")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static.dierqudao.com/images/icon-questionred.png",
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row-yf gray"
  }, [_c('div', {
    staticClass: "row-left"
  }, [_vm._v("已售 " + _vm._s(_vm.detail.sold_count + _vm.detail.sold_show_count))])]), _vm._v(" "), _c('div', {
    staticClass: "share-box share-right"
  }, [(_vm.detail.max_seller_reward > 0) ? _c('div', {
    staticClass: "share-right-text",
    on: {
      "click": _vm.getShare
    }
  }, [_vm._v("分享好友可赚 "), _c('div', [_vm._v("￥" + _vm._s(_vm.detail.max_seller_reward / 100))])]) : _c('div', {
    staticClass: "share-right-texts",
    on: {
      "click": _vm.getShare
    }
  }, [_vm._v("分享给好友")])])]), _vm._v(" "), _c('div', {
    staticClass: "row-list app-border-top"
  }, _vm._l((_vm.detail.extra_data), function(item, index) {
    return _c('div', {
      staticClass: "app-border-bottom flex-between row-one"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.value))])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "detail-img",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  }), _vm._v(" "), _c('CopyRight'), _vm._v(" "), _c('van-goods-action', {
    staticClass: "goods-footer"
  }, [_c('van-goods-action-button', {
    attrs: {
      "primary": "",
      "text": "立即购买",
      "type": "danger"
    },
    on: {
      "click": _vm.toBuy
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sku-container"
  }, [_c('van-sku', {
    attrs: {
      "sku": _vm.skuData.sku,
      "goods": _vm.skuData.goods,
      "goods-id": _vm.skuData.goods_id,
      "quota": _vm.skuData.quota,
      "quota-used": _vm.skuData.quotaUsed,
      "custom-stepper-config": _vm.customStepperConfig,
      "hide-stock": _vm.skuData.hide_stock,
      "close-on-click-overlay": _vm.closeOnClickOverlay,
      "message-config": _vm.messageConfig
    },
    on: {
      "add-cart": _vm.onAddCartClicked,
      "buy-clicked": _vm.onBuyClicked
    },
    scopedSlots: _vm._u([{
      key: "sku-actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "van-sku-actions"
        }, [_c('van-button', {
          attrs: {
            "square": "",
            "size": "large",
            "type": "warning"
          }
        }, [_vm._v("\n                        积分兑换\n                    ")]), _vm._v(" "), _c('van-button', {
          attrs: {
            "square": "",
            "size": "large",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return props.skuEventBus.$emit('sku:buy');
            }
          }
        }, [_vm._v("\n                        立即购买\n                    ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showSkuPicker),
      callback: function($$v) {
        _vm.showSkuPicker = $$v
      },
      expression: "showSkuPicker"
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('ShareDialog', {
    attrs: {
      "show": _vm.shareShow,
      "reward": _vm.detail.max_seller_reward,
      "goods_id": _vm.detail.id,
      "share": _vm.share
    },
    on: {
      "shareCancel": _vm.shareCancel
    }
  }), _vm._v(" "), _c('BookDialog', {
    attrs: {
      "show": _vm.bookDialogShow,
      "wxNote": _vm.chat.note,
      "wxCode": _vm.chat.wxcode,
      "wxPic": _vm.chat.pic_url,
      "phone": _vm.chat.phone
    },
    on: {
      "onBookCancle": _vm.onBookCancle
    }
  })], 1), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": _vm.onShareCancel
    }
  }, [_vm._m(1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-title"
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("商品详情")]), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-425bfd72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/goods/ShopGoodsDetailSellerShare.vue
// module id = 2342
// module chunks = 0